import React from 'react';
import { Modal, Button } from 'Components';
import LMSButton from 'LearningManager/components/Button';
import styles from './BulkResetModal.module.scss';

interface BulkResetModalProps {
	visible: boolean;
	selectedCount: number;
	totalUserCount?: number;
	entityType?: 'assignment' | 'course';
	onCancel: () => void;
	onConfirm: () => void;
}

const BulkResetModal: React.FC<BulkResetModalProps> = ({
	visible,
	selectedCount,
	totalUserCount = 0,
	entityType = 'assignment',
	onCancel,
	onConfirm
}) => {
	const isAssignment = entityType === 'assignment';

	return (
		<Modal
			visible={visible}
			title="Reset training?"
			onCancel={onCancel}
			size="sm"
			className={styles.modal}
			footer={
				<div className={styles.footer}>
					<LMSButton
						size="small"
						variant="borderless"
						type="default"
						onClick={onCancel}
					>
						Cancel
					</LMSButton>
					<LMSButton type="primary" size="small" onClick={onConfirm}>
						Reset
					</LMSButton>
				</div>
			}
		>
			<div className={styles.body}>
				<p className={styles.text}>
					{isAssignment ? (
						<>
							This action will reset the assignment progress for{' '}
							<strong>
								{selectedCount} of {totalUserCount}
							</strong>{' '}
							users.
						</>
					) : (
						<>
							This action will reset the course for{' '}
							<strong>
								{selectedCount} of {totalUserCount}
							</strong>{' '}
							users.
						</>
					)}
				</p>
				<p className={styles.text}>
					All progress, completions, and scores related to this{' '}
					{entityType} will be permanently removed.
				</p>
				<p className={styles.text}>
					Users will need to start the {entityType} again from the
					beginning.
				</p>
				<p className={styles.text}>This action cannot be undone.</p>
			</div>
		</Modal>
	);
};

export default BulkResetModal;
